import { QueryClient } from '@tanstack/react-query'

/**
 * Create and configure QueryClient for iframe widget
 * 
 * Configuration optimized for iframe context:
 * - Disabled window focus refetching (not relevant in iframe)
 * - Conservative retry policy (2 attempts)
 * - Reasonable stale time for caching
 */
export const createQueryClient = (): QueryClient => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: 2,
        staleTime: 5 * 60 * 1000, // 5 minutes default
        refetchOnWindowFocus: false, // Disable for iframe context
        refetchOnReconnect: true, // Good for network issues
      },
      mutations: {
        retry: 1, // Less aggressive retry for mutations
      },
    },
  })
}

// Export singleton instance for the app
export const queryClient = createQueryClient() 